import { enumTypes } from '@/models/pinterest.enum';

export const tooltips = {
  noBrandPermission: "Looks like this feature isn't included in your plan!",
  noUserPermission: "Looks like you don't have permission to use this feature!",
  connectCallToAction:
    "Dash Social brings you all of the insights you love, including Pinterest! Ask your Dash Social administrator to provide you access. Or if this feature isn't in your package, contact your Customer Success Representative to try it out!",
};

export const enumLabels = {
  VISITS: 'Visits',
  TRAFFIC: 'Traffic',
  LINK_CLICKS: 'Outbound Clicks',
  SAVES: 'Saves',
  IMPRESSIONS: 'Impressions',
  ENGAGEMENT: 'Engagement Rate', // old engagement label
  ENGAGEMENT_RATE: 'Engagement Rate', // new engagement label
  ENGAGEMENTS: 'Engagements',
  CLOSEUPS: 'Pin Clicks',
  COMMENTS: 'Comments',
  VIDEO_VIEWS: 'Views',
};

export const pinUnavailableMessage = 'Pinterest failed to return any pins for this time period.';
export const pinMetricsUnavailableMessage =
  'Pinterest failed to return any pin metrics for this time period.';

export const pinterestMediaCardDefaults = {
  labels: {
    totalCloseups: 'Pin Clicks',
    engagementRate: 'Engagement Rate',
    totalImpressions: 'Impressions',
    totalClicks: 'Outbound Clicks',
    totalSaves: 'Saves',
    videoViews: 'Video Views',
    averageWatchTime: 'Average Watch Time',
  },
  metrics: ['engagementRate', 'totalSaves', 'totalImpressions', 'totalCloseups', 'videoViews'],
};

export const pinterestMetricsToCardDetails = {
  engagementRate: 'engagementRate',
  totalSaves: 'saves',
  totalImpressions: 'impressions',
  totalCloseups: 'closeups',
  totalClicks: 'linkClicks',
  videoViews: 'videoViews',
  averageWatchTime: 'averageWatchTime',
};

export const pinterestMediaCardSortToMetric = {
  '-TOTAL_SAVES': 'totalSaves',
  '-TOTAL_CLICKS': 'totalClicks',
  '-TOTAL_CLOSEUPS': 'totalCloseups',
  '-TOTAL_IMPRESSIONS': 'totalImpressions',
  '-TOTAL_ENGAGEMENT': 'engagementRate',
  '-TOTAL_VIDEO_VIEWS': 'videoViews',
  '-AVERAGE_VIDEO_WATCH_TIME': 'averageWatchTime',
};

export const pinterestConnectionMessages = {
  title: `Connect your Pinterest Account`,
  message: `To see account insights you are required to connect your Pinterest account.`,
};

export const routeNames = {
  YOUR_PINS: 'pinterest.insights.pins',
};

export const pinterestGalleriesDetailSortOptions = [
  {
    label: 'Recently Published',
    value: '-DATE',
  },
  {
    label: 'Engagement Rate',
    value: '-PINTEREST_ENGAGEMENT',
    field: 'engagement',
  },
  {
    label: 'Outbound Clicks',
    value: '-PINTEREST_CLICKS',
    field: 'totalClicks',
  },
  {
    label: 'Saves',
    value: '-PINTEREST_SAVES',
    field: 'totalSaves',
  },
  {
    label: 'Impressions',
    value: '-PINTEREST_IMPRESSIONS',
    field: 'totalImpressions',
  },
  {
    label: 'Pin Clicks',
    value: '-PINTEREST_CLOSEUPS',
    field: 'totalCloseups',
  },
  {
    label: 'Video Views',
    value: '-PINTEREST_VIDEO_VIEWS',
    field: 'totalVideoViews',
  },
  {
    label: 'Average Watch Time',
    value: '-PINTEREST_AVERAGE_VIDEO_WATCH_TIME',
    field: 'averageVideoWatchTime',
  },
];

export const pinterestGalleryCardDefaults = {
  metrics: ['pinterestAvgEngagementRate', 'pinterestTotalClicks', 'pinterestTotalSaves'],
  labels: {
    pinterestAvgEngagementRate: 'Avg. Engagement Rate',
    pinterestTotalClicks: 'Outbound Clicks',
    pinterestTotalSaves: 'Saves',
  },
};

export const pinterestMetricFormats = {
  pinterestAvgEngagementRate: 'percent',
};

/** @type {import('@dashhudson/dashing-ui/utils/query').QueryParamMappings} */
const followersQueryParamMapping = {
  'reportingPeriod.range.start': { queryParamName: 'startDate', type: 'date' },
  'reportingPeriod.range.end': { queryParamName: 'endDate', type: 'date' },
  viewGraphBy: { queryParamName: 'scale', type: 'string' },
};

export const FOLLOWERS_FILTER_DETAILS = Object.freeze({
  scope: 'pinterestFollowers',
  title: 'Pinterest Followers',
  options: {
    reportingPeriod: {},
    viewGraphBy: [
      { value: enumTypes.DAILY, label: 'Day' },
      { value: enumTypes.MONTHLY, label: 'Month' },
    ],
  },
  default: {
    reportingPeriod: {
      preset: 'LAST_7_DAYS',
    },
    viewGraphBy: enumTypes.DAILY,
  },
  queryParamMapping: followersQueryParamMapping,
});
